import { toast } from 'react-toastify';

import { CheckCircle } from '@phosphor-icons/react';

const NotificationSuccess = (message: string) => {
  toast.success(message, {
    icon: () => <CheckCircle size={24} color='#22C55E' />,
  });
};

export default NotificationSuccess;
